@if (responseMessage.success) {
  <div class="bn-dialog modal-sm mx-auto">
    <div class="bn-dialog__icon bn-dialog__icon--success">
      <fa-icon icon="circle-check" />
    </div>
    <div class="bn-dialog__title text-center">SSL verification!</div>
    <div class="bn-dialog__body text-center">
      <p>SSL Verification was successful.</p>
    </div>
    <div class="bn-dialog__actions">
      <button
        bn-web-ui-button
        size="lg"
        type="button"
        [fullWidth]="true"
        (click)="bsModalRef.hide()">
        Okay, Got It
      </button>
    </div>
  </div>
} @else {
  <div class="bn-dialog mx-auto">
    <div class="bn-dialog__icon bn-dialog__icon--align-left bn-dialog__icon--warning">
      <fa-icon icon="gear" />
    </div>
    <div class="bn-dialog__title mb-2">Set up your hostname</div>

    <div class="bn-dialog__body d-flex flex-column gap-3">
      @if (dnsCheckState === 'loading') {
        <div class="d-flex align-items-center gap-2">
          <div
            class="bn-loading__spinner"
            style="width: 20px; height: 20px; border-width: 3px; margin: 0; flex-shrink: 0"></div>
          <p class="m-0">Checking your DNS zones&hellip;</p>
        </div>
      }

      @if (dnsCheckState === 'auto-configured') {
        <bn-web-ui-alert
          alertType="success"
          headerIcon="circle-check"
          [showIcon]="true">
          Your domain was found in your
          <a
            [routerLink]="['/dns/zones', foundDnsZoneId, 'dnsrecords']"
            (click)="bsModalRef.hide()"
            >DNS zone</a
          >
          and the CNAME record has been configured automatically. Click <strong>Verify &amp; Activate SSL</strong> to issue the certificate.
        </bn-web-ui-alert>
        <a
          href="javascript:void(0)"
          (click)="showInstructions = !showInstructions">
          {{ showInstructions ? 'Hide instructions' : 'Show manual instructions' }}
        </a>
      }

      @if (dnsCheckState === 'cname-error') {
        <bn-web-ui-alert
          alertType="warning"
          headerIcon="triangle-exclamation"
          [showIcon]="true">
          Your domain was found in your
          <a
            [routerLink]="['/dns/zones', foundDnsZoneId, 'dnsrecords']"
            (click)="bsModalRef.hide()"
            >DNS zone</a
          >
          but the CNAME record could not be added automatically. Please add it manually using the settings below.
        </bn-web-ui-alert>
      }

      @if (dnsCheckState === 'cname-wrong-value') {
        <bn-web-ui-alert
          alertType="warning"
          headerIcon="triangle-exclamation"
          [showIcon]="true">
          A CNAME record already exists in your
          <a
            [routerLink]="['/dns/zones', foundDnsZoneId, 'dnsrecords']"
            (click)="bsModalRef.hide()"
            >DNS zone</a
          >
          but points to a different target. Update it to the value shown below to activate SSL.
        </bn-web-ui-alert>
      }

      @if (dnsCheckState === 'manual') {
        <p class="m-0">To activate your custom hostname, please create a CNAME DNS record with the following settings:</p>
      }

      @if (
        dnsCheckState === 'manual' ||
        dnsCheckState === 'cname-error' ||
        dnsCheckState === 'cname-wrong-value' ||
        (dnsCheckState === 'auto-configured' && showInstructions)
      ) {
        <bn-web-ui-input
          inputName="Domain"
          label="CNAME domain"
          [options]="{ rightAddons: [{ icon: 'copy', action: 'copyToClipboard', tooltip: 'Copy to clipboard' }] }"
          [readonly]="true"
          [(ngModel)]="hostname" />

        <bn-web-ui-input
          inputName="Name"
          label="CNAME value"
          [options]="{ rightAddons: [{ icon: 'copy', action: 'copyToClipboard', tooltip: 'Copy to clipboard' }] }"
          [readonly]="true"
          [(ngModel)]="value" />

        <p class="m-0">Once the domain is activated, it will be automatically configured with SSL and connected to this endpoint.</p>
      }

      @if (!responseMessage.success && responseMessage.text) {
        <div class="bn-dialog__message">
          <bn-web-ui-alert
            alertType="danger"
            headerIcon="circle-xmark"
            [showIcon]="true">
            {{ responseMessage.text }}
          </bn-web-ui-alert>
        </div>
      }
    </div>

    <div class="bn-dialog__actions d-inline-flex w-100">
      @if (dnsCheckError) {
        <button
          bn-web-ui-button
          class="me-2"
          size="lg"
          type="button"
          [loading]="isLoadingFreeSSL()"
          (click)="forceActivateSSL()">
          Force Activate SSL
        </button>

        <button
          bn-web-ui-button
          itemStyle="stroke"
          size="lg"
          type="button"
          [disabled]="isLoadingFreeSSL()"
          (click)="bsModalRef.hide()">
          Skip Verification
        </button>
      } @else {
        <button
          bn-web-ui-button
          class="me-2"
          size="lg"
          type="button"
          [disabled]="dnsCheckState === 'loading' || dnsCheckError"
          [loading]="isLoadingFreeSSL() || isLoadingCheckDns()"
          (click)="verifySSL()">
          Verify & Activate SSL
        </button>

        <button
          bn-web-ui-button
          itemStyle="stroke"
          size="lg"
          type="button"
          [disabled]="dnsCheckState === 'loading' || isLoadingFreeSSL() || isLoadingCheckDns()"
          (click)="bsModalRef.hide()">
          Skip Verification
        </button>
      }
    </div>
  </div>
}
